// extracted by mini-css-extract-plugin
module.exports = {"message":"message__R1d+J","messageIcon":"messageIcon__LuDTJ"};